module.exports = __webpack_public_path__ + "static/img/10_clovers.cb15213.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/10_clovers.svg
// module id = Ip1o
// module chunks = 1